import 'jquery-mask-plugin';
import validate from 'jquery-validation';

export default () => {
  window.correctCaptcha = function() {
    $('.contact-form__recaptcha-error').hide();
    return false;
  };

  $('.js-contact-phone').mask('+0(000)000-00-00');

  $('.js-contact-form').validate({
    rules: {
      name: {
        required: true,
        minlength: 3,
        lettersonly: true,
      },
      phone: {
        required: true,
        minlength: 16,
      },
      email: {
        required: true,
        email: true
      },
      message: {
        required: true,
      },
    },
    messages: {
      name: {
        required: 'Это поле обязательно к заполнению.',
        minlength: 'Имя не может состоять менее, чем, из трех букв.',
        lettersonly: 'Имя должно содержать только буквы',
      },
      phone: {
        required: 'Это поле обязательно к заполнению.',
        minlength: 'Неверный формат номера телефона.',
      },
      email: {
        required: "Это поле обязательно к заполнению.",
        email: "Ваш адрес электронной почты должен быть в формате name@domain.com.",
      },
      message: {
        required: "Это поле обязательно к заполнению.",
      },
    },
    errorClass: 'contact-form__error',
    validClass: 'contact-form__success',
    errorElement: 'div',
    submitHandler: function (form, event) {
      event.preventDefault();
      const $form = $(form);

      if (!grecaptcha.getResponse()) {
        $form.find('.contact-form__recaptcha-error').show();
      }

      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        success(data) {
          alert("Ваша заявка успешно отправлена!");
        },
        error(xhr) {
          console.log(`Error ${xhr.status} ${xhr.statusText}`);
        },
      });
      return false;
    },
  });

  jQuery.validator.addMethod("lettersonly", function (value, element) {
    return this.optional(element) || /^([^\x00-\x7F]|[a-zA-Z])+$/i.test(value);
  }, "Only alphabetical characters");
};



// WEBPACK FOOTER //
// ./resources/assets/js/blocks/contact-form/index.js